import { INHOUSE_STATUS_MAP } from '../constants';

const prepareInhouseOptions = (values, itemId) => {
  const email = values.email || '';
  const sms = values.sms.replace(/\D/g, '') || '';
  return {
    method: 'POST',
    crossdomain: false,
    headers: { 'Content-Type': 'application/json' },
    dataType: 'json',
    body: JSON.stringify({ emailId: email, phoneNumber: sms, omsId: itemId })
  };
};

const prepareExternalUrl = (hosts) => {
  const { trackif = '' } = hosts || {};
  return `${trackif}/tools/auto`;
};

const prepareExternalOptions = (values, path) => {
  let itemURL = path;

  if (typeof window !== 'undefined' && window?.location) {
    const { origin, pathname } = window.location;
    itemURL = `${origin}${pathname}`;
  }

  const formData = new FormData();
  formData.append('email', values.email);
  formData.append('url', itemURL);
  formData.append('preset', 'out-of-stock');

  return {
    method: 'POST',
    crossdomain: true,
    dataType: 'json',
    body: formData
  };
};

const prepareNotificationData = (values, itemId, statusRef, context) => {
  const { path, hosts } = context;
  if (itemId) {
    return {
      url: '/discovery/opt/in',
      options: prepareInhouseOptions(values, itemId),
      itemId,
      statusRef
    };
  }

  if (path) {
    return {
      url: prepareExternalUrl(hosts),
      options: prepareExternalOptions(values, path),
      itemId,
      statusRef
    };
  }

  statusRef.current.push({
    loader: false,
    status: 'failure'
  });
  return null;
};

const sendNotification = async ({ url, options, itemId, statusRef }) => {
  try {
    const response = await fetch(url, options).then((resp) => resp.json());
    const newStatus = itemId ? INHOUSE_STATUS_MAP[response.message] : response.status;
    statusRef.current.push({
      loader: false,
      status: newStatus || 'failure'
    });
  } catch {
    statusRef.current.push({
      loader: false,
      status: 'failure'
    });
  }
};

export const submitForm = async (values, itemId, statusRef, context) => {
  const notificationData = prepareNotificationData(values, itemId, statusRef, context);
  if (!notificationData) {
    return;
  }
  await sendNotification(notificationData);
};

export const validateForm = (values, updateState, enableSms) => {
  const errors = {};
  if (!values.email && !values.sms && enableSms) {
    errors.email = 'Please provide your email address, formatted as you@domain.com.';
    errors.sms = 'Please provide your phone number.';
    updateState('contact_missing', false);
  }
  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = 'Please provide a valid email address.';
    updateState('email_missing', false);
  }
  if (values.sms.length !== 14 && values.sms) {
    errors.sms = 'Phone number must be 10 digits.';
    updateState('phone_missing', false);
  }
  return errors;
};

export const findItemByStatus = (statusRef, status) => {
  return statusRef?.current?.find((itemStatus) => itemStatus?.status === status);
};